module.exports = __webpack_public_path__ + "dd24fdedabbefe22d53a86ced08ea698.svg";